// Copyright © Veeam Software Group GmbH

export const EXPLORE_PAGE_LIMIT = 500;
